import { Secondary, Text, TextLink } from 'braid-design-system';
import { useLanguage, useTranslations } from '@vocab/react';
import translations from './.vocab';
import { getLanguagePrefixedPath } from 'src/utils/getLanguagePrefixedPath';
import analytics from 'src/modules/analytics';
import type { PageAnalytics } from 'src/reducers/page';
import type { UserDetails } from 'src/reducers/user';
import type { Language } from '@seek/ca-myprofile-utils';

interface Props {
  originator: string;
  pageAnalytics: PageAnalytics;
  userDetails?: UserDetails;
}

export const DontHavePasswordLink = (props: Props) => {
  const { originator, pageAnalytics, userDetails } = props;
  const { t } = useTranslations(translations);
  const { language } = useLanguage();
  const { trackLink } = analytics({});

  return (
    <Text>
      <Secondary>
        {t('DontHavePassword', {
          TextLink: (children) => (
            <TextLink
              href={getLanguagePrefixedPath(
                language as Language,
                `/oauth/forgot-password`,
              )}
              weight="weak"
              hitArea="large"
              target="_blank"
              onClick={() =>
                trackLink({
                  currentPageSection: originator,
                  eventName: 'create_password_pressed',
                  currentPage: 'account settings',
                  ...pageAnalytics,
                  ...userDetails,
                })
              }
            >
              {children}
            </TextLink>
          ),
        })}
      </Secondary>
    </Text>
  );
};
